<template>
  <div class="page-detail-lxgc">
    <!-- 基本信息 -->
    <div class="section-title">| 基本信息</div>
    <div class="section-body">
      <div class="info-row">
        <span class="info-field info-field-wrap">
          <span class="info-label">{{ detail.fromType === '1' ? '报修人姓名：' : '需求人姓名：' }}</span>
          <span class="info-value">{{ detail.requesterName || '-' }}</span>
        </span>
        <span class="info-field">
          <span class="info-label">手机号：</span>
          <span class="info-value">{{ detail.phone || '-' }}</span>
        </span>
        <span class="info-field">
          <span class="info-label">{{ detail.fromType === '1' ? '报修类型：' : '施工类型：' }}</span>
          <span class="info-value">{{ detail.bxlxName || '-' }}</span>
        </span>
        <span class="info-field">
          <span class="info-label">报修地点：</span>
          <span class="info-value">{{ detail.address || '-' }}</span>
        </span>
        <span class="info-field info-field-wrap">
          <span class="info-label">详细地址：</span>
          <span class="info-value">{{ detail.detailAddress || '-' }}</span>
        </span>
        <span class="info-field">
          <span class="info-label">供应商：</span>
          <span class="info-value">{{ detail.gysName || '-' }}</span>
        </span>
      </div>
      <div class="info-row-full">
        <span class="info-label">{{ detail.fromType === '1' ? '故障描述：' : '项目描述：' }}</span>
        <span class="info-value info-value-multiline">{{ detail.projectDescription || '-' }}</span>
      </div>
      <div class="info-row-full">
        <span class="info-label">{{ detail.fromType === '1' ? '报修图片：：' : '项目图片：' }}</span>
        <div class="img-list" v-if="imgList.length">
          <a-upload :file-list="imgList" list-type="picture-card" :show-upload-button="false" :disabled="true" @preview="handlePreview" />
        </div>
        <span v-else class="info-value">-</span>
      </div>
    </div>

    <!-- 报价分项信息 -->
    <div class="section-title">| 分项信息</div>
    <div class="section-body">
      <div class="info-row-full">
        <span class="info-label">方案描述：</span>
        <span class="info-value info-value-multiline">{{ stageInfo.solutionDescription || '-' }}</span>
      </div>
      <div class="info-row-full">
        <span class="info-label">方案文件：</span>
        <div v-if="stageInfo.fileList && stageInfo.fileList.length" class="file-list">
          <div v-for="(file, index) in stageInfo.fileList" :key="index" class="file-item">
            <a :href="file.fileFullName" target="_blank" class="file-link">{{ file.fileName || '附件' }}</a>
          </div>
        </div>
        <span v-else class="info-value">-</span>
      </div>
      <div class="info-row-full" v-if="stageInfo.startDate || stageInfo.endDate">
        <span class="info-label">工期：</span>
        <span class="info-value">{{ stageInfo.startDate }}至{{ stageInfo.endDate }}</span>
      </div>
      <div class="table-wrapper">
        <a-table
          :columns="columns"
          :data-source="projectList"
          :pagination="pagination"
          :row-key="(_, i) => String(i)"
          :scroll="{ x: 1120 }"
          bordered
          @change="handleTableChange"
          style="margin-top: 16px;"
        >
          <template slot="index" slot-scope="text, record, index">
            {{ (pagination.current - 1) * pagination.pageSize + index + 1 }}
          </template>
          <template slot="isCenterPurchasingPrice" slot-scope="text">
            {{ text === '1' ? '是' : '否' }}
          </template>
          <template slot="projectCharacteristics" slot-scope="text">
            <div class="cell-multiline">{{ text || '-' }}</div>
          </template>
          <template slot="remark" slot-scope="text">
            <div class="cell-multiline">{{ text || '-' }}</div>
          </template>
        </a-table>
        <div class="total-row">合计（元）：{{ totalPrice }}</div>
      </div>
    </div>

    <!-- 审核信息 -->
    <div class="section-title" v-if="auditList.length > 0">| 审核信息</div>
    <div class="section-body" v-if="auditList.length > 0">
      <a-table
        :columns="auditColumns"
        :data-source="auditList"
        :pagination="false"
        :row-key="(_, i) => String(i)"
        :scroll="{ x: 680 }"
        bordered
      >
        <template slot="auditStatus" slot-scope="text">
          {{ text === '1' ? '同意' : '驳回' }}
        </template>
        <template slot="auditFile" slot-scope="text, record">
          <a v-if="record.fileUrl" :href="record.fileUrl" target="_blank" class="file-link">{{ text || '附件' }}</a>
          <span v-else>-</span>
        </template>
      </a-table>
    </div>

    <!-- 审批操作 -->
    <div class="section-title" v-if="canAudit">| 审批</div>
    <div class="section-body" v-if="canAudit">
      <a-form :form="auditForm" :label-col="{ span: 4 }" :wrapper-col="{ span: 16 }">
        <a-form-item label="审核结果">
          <a-radio-group
            v-decorator="['auditStatus', { rules: [{ required: true, message: '请选择审核结果' }] }]"
          >
            <a-radio value="1">通过</a-radio>
            <a-radio value="0">驳回</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="审批意见" required>
          <a-textarea
            v-decorator="['auditDescription', {
              rules: [
                { required: true, message: '请输入审批意见' },
                { max: 200, message: '最多200个字符' }
              ]
            }]"
            :rows="4"
            placeholder="请输入审批意见"
            :maxLength="200"
            style="max-width: 480px;"
          />
        </a-form-item>
        <a-form-item label="附件">
          <div class="audit-file-uploader">
            <a-upload
              :before-upload="beforeUpload"
              :show-upload-list="false"
              accept=".jpg,.jpeg,.png,.JPG,.JPEG,.PNG,.doc,.pdf,.ppt,.docx,.pptx,.xls,.xlsx"
            >
              <a-button type="primary" icon="upload" class="audit-upload-btn">上传</a-button>
            </a-upload>
            <div class="audit-file-tip">支持的文件格式：.jpg,.jpeg,.png,.JPG,.JPEG,.PNG,.doc,.pdf,.ppt,.docx,.pptx,.xls,.xlsx，大小不超过200M</div>
            <div v-if="fileList.length > 0" class="audit-file-item">
              <a-icon :type="getFileIcon(fileList[0].name)" class="audit-file-icon" />
              <span class="audit-file-name">{{ fileList[0].name }}</span>
              <a-upload
                :before-upload="beforeUpload"
                :show-upload-list="false"
                accept=".jpg,.jpeg,.png,.JPG,.JPEG,.PNG,.doc,.pdf,.ppt,.docx,.pptx,.xls,.xlsx"
                class="audit-file-replace"
              >
                <a class="audit-file-link">重新上传</a>
              </a-upload>
              <a class="audit-file-link audit-file-remove" @click="handleRemoveFile">删除</a>
            </div>
          </div>
        </a-form-item>
        <a-form-item :wrapper-col="{ offset: 4 }">
          <a-button type="primary" :loading="submitting" @click="handleSubmit">提交审批</a-button>
          <a-button style="margin-left: 8px;" @click="handleCancel">取消</a-button>
        </a-form-item>
      </a-form>
    </div>
    <div class="section-body" v-else>
      <a-alert message="当前审批阶段您无审批权限" type="info" show-icon />
    </div>

    <!-- 图片预览弹窗 -->
    <a-modal :visible="previewVisible" :footer="null" @cancel="previewVisible = false">
      <img style="width: 100%;" :src="previewImage" />
    </a-modal>
  </div>
</template>

<script>
function makePagination () {
  return {
    current: 1,
    pageSize: 10,
    total: 0,
    showTotal: total => `总共${total}条数据`,
    showSizeChanger: true,
    showQuickJumper: true,
    pageSizeOptions: ['10', '20', '50']
  }
}

export default {
  name: 'QuoteApproval',
  data () {
    return {
      detail: {},
      stageInfo: { solutionDescription: '', startDate: '', endDate: '', fileList: [] },
      imgList: [],
      previewVisible: false,
      previewImage: '',
      projectList: [],
      totalPrice: '0.00',
      pagination: makePagination(),
      auditList: [],
      auditForm: this.$form.createForm(this),
      submitting: false,
      fileList: [],
      canAudit: false,
      columns: [
        { title: '序号', scopedSlots: { customRender: 'index' }, width: 60, align: 'center' },
        { title: '是否集采价', dataIndex: 'isCenterPurchasingPrice', scopedSlots: { customRender: 'isCenterPurchasingPrice' }, width: 100, align: 'center' },
        { title: '分项工程名称', dataIndex: 'projectName', width: 150, align: 'center' },
        { title: '项目特征描述', dataIndex: 'projectCharacteristics', scopedSlots: { customRender: 'projectCharacteristics' }, width: 200, align: 'center' },
        { title: '单位', dataIndex: 'unit', width: 80, align: 'center' },
        { title: '工程量', dataIndex: 'projectQuantity', width: 80, align: 'center' },
        { title: '全费用综合单价（元）', dataIndex: 'price', width: 180, align: 'center' },
        { title: '含税合价（元）', dataIndex: 'totalPrice', width: 120, align: 'center' },
        { title: '备注', dataIndex: 'remark', scopedSlots: { customRender: 'remark' }, width: 150, align: 'center' }
      ],
      auditColumns: [
        { title: '审核人', dataIndex: 'auditor', width: 100, align: 'center' },
        { title: '审核时间', dataIndex: 'auditDate', width: 160, align: 'center' },
        { title: '审核结果', dataIndex: 'auditStatus', scopedSlots: { customRender: 'auditStatus' }, width: 100, align: 'center' },
        { title: '审核意见', dataIndex: 'auditDescription', width: 200, align: 'center' },
        { title: '附件', dataIndex: 'fileName', scopedSlots: { customRender: 'auditFile' }, width: 120, align: 'center' }
      ]
    }
  },
  mounted () {
    const id = this.$route.query.id
    if (id) {
      this.loadDetail(id)
      this.loadStageInfo()
      this.loadProjectList()
      this.loadAuditList()
    }
  },
  methods: {
    loadDetail (id) {
      this.$axios.post('/api/lxgc/detail.do', { id, step: '1' }).then(res => {
        this.detail = (res.data && res.data.data) || {}
        this.canAudit = res.data && res.data.canAudit !== undefined ? res.data.canAudit : false
        const imgList = (res.data && res.data.imgList) || []
        this.imgList = imgList.map((item, i) => ({
          uid: item.id || String(i),
          name: item.fileName || `图片${i + 1}`,
          status: 'done',
          thumbUrl: item.fileFullName,
          url: item.fileFullName
        }))
      })
    },
    loadStageInfo () {
      this.$axios.post('/api/lxgc/stageInfoList.do', {
        lxgcId: this.$route.query.id
      }).then(res => {
        const data = (res && res.data) || {}
        const info = data.bj || {}
        this.stageInfo = {
          solutionDescription: info.solutionDescription || '',
          startDate: info.startDate || '',
          endDate: info.endDate || '',
          fileList: info.fileList || []
        }
      })
    },
    loadProjectList () {
      this.$axios.post('/api/lxgc/allProjectList.do', {
        lxgcId: this.$route.query.id
      }).then(res => {
        const data = (res && res.data) || {}
        this.projectList = data.bj || []
        this.pagination = { ...this.pagination, total: this.projectList.length }
        this.calcTotal()
      })
    },
    calcTotal () {
      const sum = this.projectList.reduce((acc, row) => acc + (parseFloat(row.totalPrice) || 0), 0)
      this.totalPrice = sum.toFixed(2)
    },
    handleTableChange (pager) {
      this.pagination = { ...this.pagination, current: pager.current, pageSize: pager.pageSize }
    },
    loadAuditList () {
      this.$axios.post('/api/lxgc/allAuditList.do', {
        lxgcId: this.$route.query.id
      }).then(res => {
        const data = (res && res.data) || {}
        this.auditList = data.bj || []
      })
    },
    handlePreview (file) {
      this.previewImage = file.url
      this.previewVisible = true
    },
    beforeUpload (file) {
      const isLt200M = file.size / 1024 / 1024 < 200
      if (!isLt200M) {
        this.$message.error('文件大小不能超过200M')
        return false
      }
      this.fileList = [file]
      return false
    },
    handleRemoveFile () {
      this.fileList = []
    },
    getFileIcon (fileName) {
      if (!fileName) return 'file'
      const ext = fileName.split('.').pop().toLowerCase()
      if (['pdf'].includes(ext)) return 'file-pdf'
      if (['doc', 'docx'].includes(ext)) return 'file-word'
      if (['xls', 'xlsx'].includes(ext)) return 'file-excel'
      if (['jpg', 'jpeg', 'png', 'gif', 'bmp'].includes(ext)) return 'file-image'
      return 'file'
    },
    handleSubmit () {
      this.auditForm.validateFields((err, values) => {
        if (err) return
        this.submitting = true
        const formData = new FormData()
        formData.append('lxgcId', this.$route.query.id)
        formData.append('step', '1')
        formData.append('auditStatus', values.auditStatus)
        formData.append('auditDescription', values.auditDescription || '')
        if (this.fileList.length > 0) {
          formData.append('file', this.fileList[0])
        }
        this.$axios.post('/api/lxgc/audit.do', formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        }).then(() => {
          this.$message.success('审批提交成功')
          this.$router.push({ path: '/minorWorks' })
        }).finally(() => {
          this.submitting = false
        })
      })
    },
    handleCancel () {
      this.$router.push({ path: '/minorWorks' })
    }
  }
}
</script>

<style lang="less" scoped>
.page-detail-lxgc {
  background: #fff;
  padding: 24px;
  min-height: calc(100vh - 64px);

  .section-title {
    color: #1890ff;
    font-size: 14px;
    margin-bottom: 16px;
    margin-top: 24px;

    &:first-child {
      margin-top: 0;
    }
  }

  .section-body {
    padding: 0 0 16px 16px;

    .info-row {
      display: flex;
      flex-wrap: wrap;
      align-items: baseline;
      margin-bottom: 16px;

      .info-field {
        margin-right: 48px;
        margin-bottom: 8px;
      }

      .info-field-wrap {
        display: inline-flex;
        align-items: flex-start;
        max-width: 100%;

        .info-value {
          word-break: break-all;
          white-space: normal;
        }
      }
    }

    .info-row-full {
      display: flex;
      align-items: flex-start;
      margin-bottom: 16px;
      flex-wrap: wrap;
    }

    .info-label {
      color: rgba(0, 0, 0, 0.65);
      font-size: 14px;
      white-space: nowrap;
    }

    .info-value {
      color: rgba(0, 0, 0, 0.85);
      font-size: 14px;
    }

    .info-value-multiline {
      word-break: break-all;
      white-space: pre-wrap;
      flex: 1;
      max-width: calc(100% - 100px);
    }

    .cell-multiline {
      word-break: break-word;
      overflow-wrap: break-word;
      white-space: pre-wrap;
      text-align: left;
      min-width: 120px;
    }

    .file-link {
      color: #1890ff;
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }

    .file-list {
      display: flex;
      flex-direction: column;
      gap: 8px;
      margin-top: 4px;

      .file-item {
        display: flex;
        align-items: center;
      }
    }

    .img-list {
      margin-top: 4px;
    }

    .audit-file-uploader {
      .audit-upload-btn {
        background: #1890ff;
        border-color: #1890ff;
      }

      .audit-file-tip {
        margin-top: 8px;
        font-size: 12px;
        color: rgba(0, 0, 0, 0.45);
        line-height: 18px;
      }

      .audit-file-item {
        display: inline-flex;
        align-items: center;
        margin-top: 8px;
        padding: 4px 12px;
        background: #fafafa;
        border: 1px solid #e8e8e8;
        border-radius: 4px;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.85);

        .audit-file-icon {
          font-size: 18px;
          color: #1890ff;
          margin-right: 8px;
        }

        .audit-file-name {
          max-width: 320px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          margin-right: 16px;
        }

        .audit-file-link {
          color: #1890ff;
          margin-left: 8px;
          cursor: pointer;

          &:hover {
            text-decoration: underline;
          }
        }

        .audit-file-replace {
          display: inline-block;
        }
      }
    }
  }

  .table-wrapper {
    position: relative;
    margin-top: 16px;

    .total-row {
      position: absolute;
      bottom: 10px;
      left: 0;
      line-height: 32px;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.85);
      font-weight: 500;
    }
  }
}
</style>
